import { TFormValues } from '../productForm.types'
import { CategoryAttributeModel } from '../../../../server/mpsklad_core/Models/MpCard/CategoryAttributeModel'

export const mapFormValuesToFormData = (formValues: TFormValues,
                                        options?: {deletedImageIds?: string[]; productId?: string; moySkladProductId?: number}): FormData => {
  const formData = new FormData()

  const bothAttrs: CategoryAttributeModel[] = formValues.description
                                              ? [
      ...formValues.attributes,
      formValues.description,
      ...formValues.ozon.attributes,
      ...formValues.wildberries.attributes,
      ...formValues.yandexMarket.attributes,
      ...formValues.moySklad.attributes
    ]
                                              : [
      ...formValues.attributes,
      ...formValues.ozon.attributes,
      ...formValues.wildberries.attributes,
      ...formValues.yandexMarket.attributes,
      ...formValues.moySklad.attributes
    ]

  formData.append('isOzonCard', String(formValues.ozon.include))
  formData.append('isWildberriesCard', String(formValues.wildberries.include))
  formData.append('isYandexMarkertCard', String(formValues.yandexMarket.include))
  formData.append('isMoySkladCard', String(formValues.moySklad.include))

  if (formValues.ozon.category?.id) {
    formData.append('ozonProductCategoryId', String(formValues.ozon.category.id))
  }
  if (formValues.wildberries.category?.id) {
    formData.append('wbProductCategoryId', String(formValues.wildberries.category.id))
  }
  if (formValues.yandexMarket.category?.id) {
    formData.append('yandexMarketProductCategoryId', String(formValues.yandexMarket.category.id))
  }

  const filteredAttrs = bothAttrs.filter(attr => {
    return !(attr.enumValues?.length > 0 && !attr.currentValue)
  })

  filteredAttrs.forEach((attr, index) => {
    formData.append(`attributes[${index}].categoryAttributeId`, String(attr.id))
    formData.append(`attributes[${index}].value`, attr.currentValue ?? '')
    formData.append(`attributes[${index}].unit`, attr.unit ?? '')
  })

  if (formValues.images?.length > 0) {
    formValues.images.forEach((image, index) => {
      if ('image' in image && image.image instanceof File) {
        formData.append(`images[${index}].image`, image.image)
        formData.append(`images[${index}].order`, String(index + 1))
      } else if ('id' in image && image.id && 'url' in image && image.url) {
        formData.append(`images[${index}].id`, image.id)
        formData.append(`images[${index}].url`, image.url)
        formData.append(`images[${index}].order`, String(index + 1))
      }
    })
  }

  if (options?.productId) {
    formData.append('id', options.productId)
  }

  if (options?.moySkladProductId != null) {
    formData.append('moySkladProductId', String(options.moySkladProductId))
  }

  if (options?.deletedImageIds?.length) {
    options.deletedImageIds.forEach((id, index) => {
      formData.append(`imagesToDelete[${index}]`, id)
    })
  }

  if (formValues.variants?.length) {
    formValues.variants.forEach((variant, vIndex) => {
      formData.append(`variants[${vIndex}].vendorCode`, variant.vendorCode)
      if (variant.title) formData.append(`variants[${vIndex}].title`, variant.title)
      if (variant.description) formData.append(`variants[${vIndex}].description`, variant.description)
      if (variant.brand) formData.append(`variants[${vIndex}].brand`, variant.brand)

      // атрибуты варианта
      variant.attributes.forEach((attr, aIndex) => {
        formData.append(`variants[${vIndex}].attributes[${aIndex}].categoryAttributeId`, attr.id)
        formData.append(`variants[${vIndex}].attributes[${aIndex}].value`, attr.currentValue ?? '')
        formData.append(`variants[${vIndex}].attributes[${aIndex}].unit`, attr.unit ?? '')
      })

      // изображения варианта
      variant.images?.forEach((image, iIndex) => {
        if ('image' in image && image.image instanceof File) {
          formData.append(`variants[${vIndex}].images[${iIndex}].image`, image.image)
          formData.append(`variants[${vIndex}].images[${iIndex}].order`, String(iIndex + 1))
        } else if ('id' in image && image.id) {
          formData.append(`variants[${vIndex}].images[${iIndex}].id`, image.id)
          formData.append(`variants[${vIndex}].images[${iIndex}].order`, String(iIndex + 1))
        }
      })
    })
  }

  return formData
}
